import f from "./index820.js";
var r = typeof exports == "object" && exports && !exports.nodeType && exports, e = r && typeof module == "object" && module && !module.nodeType && module, p = e && e.exports === r, o = p ? f.Buffer : void 0;
o && o.allocUnsafe;
function l(t, u) {
  return t.slice();
}
export {
  l as default
};
